// export type SexEnum = 'M' | 'F' | 'U'

export enum SexEnum {
  male = 'M',
  female = 'F',
  unknown = 'U',
}
